<ng-container
    *ngIf="state?.pending?.reload !== true || state?.pending?.reset === true"
>
    <div class="cmps-cdk-d-flex">
        <div class="cmps-cdk-d-flex cmps-cdk-flex-grow-1 cmps-cdk-flex-wrap">
            <div
                class="cmps-cdk-d-flex cmps-cdk-mb-1 cmps-cdk-pr-1 cmps-cdk-align-items-center cmps-cdk-flex-grow-1"
            >
                <div
                    class="cmps-cdk-mr-0dot75 cmps-cdk-font-bold cmps-cdk-font-size-12p"
                >
                    {{ _i18n._11266_ASSESSMENT_PERIOD | translate }}
                </div>
                <select
                    cmpsNativeSelect
                    class="cmps-cdk-font-size-14p"
                    (change)="_onDataRangeChange($event)"
                >
                    <ng-container *ngFor="let i of state?.dataRanges">
                        <option
                            [value]="i.dataRangeId"
                            [selected]="
                                i.dataRangeId ===
                                state?.selectedDataRange?.dataRangeId
                            "
                        >
                            {{ i.label }}
                        </option>
                    </ng-container>
                </select>
            </div>

            <div
                class="cmps-cdk-d-flex cmps-cdk-mb-1 cmps-cdk-pr-1 cmps-cdk-align-items-center cmps-cdk-flex-grow-1"
            >
                <div
                    class="cmps-cdk-mr-0dot75 cmps-cdk-font-bold cmps-cdk-font-size-12p"
                >
                    {{ _i18n._11270_WINNING_PERCENTAGE_TIME_RANGE | translate }}
                </div>
                <select
                    cmpsNativeSelect
                    class="cmps-cdk-font-size-14p"
                    (change)="_onEvalRangeChange($event)"
                >
                    <ng-container
                        *ngFor="
                            let i of state?.selectedDataRange?.evaluationRanges
                        "
                    >
                        <option
                            [value]="i.evaluationRangeIsOaMetricId"
                            [selected]="
                                i.evaluationRangeIsOaMetricId ===
                                state?.selectedEvalRange
                                    ?.evaluationRangeIsOaMetricId
                            "
                        >
                            <!-- TODO revise -->
                            <ng-container
                                *ngIf="
                                    i.labelFormat?.startsWith('date:') === true
                                "
                            >
                                {{
                                    i.endDateDataRange
                                        | cmpsDate: i.labelFormat?.split(':')[1]
                                }}
                            </ng-container>
                            <ng-container
                                *ngIf="
                                    i.labelFormat?.startsWith('date:') !== true
                                "
                            >
                                {{ i.label }}
                            </ng-container>
                        </option>
                    </ng-container>
                </select>
            </div>

            <div
                class="cmps-cdk-d-flex cmps-cdk-mb-1 cmps-cdk-pr-1 cmps-cdk-align-items-center cmps-cdk-flex-grow-1"
            >
                <ng-container *ngIf="state?.hasData === true">
                    <span class="cmps-cdk-font-bold cmps-cdk-mr-0dot5">{{
                        _i18n._11268_SELECTED_TIME_RANGE | translate
                    }}</span>
                    <span
                        >{{
                            state?.period?.start | cmpsDate: 'MMM d, y'
                        }}&nbsp;-&nbsp;{{
                            state?.period?.end | cmpsDate: 'MMM d, y'
                        }}</span
                    >
                </ng-container>
            </div>

            <div
                class="cmps-cdk-d-flex cmps-cdk-mb-1 cmps-cdk-pr-1 cmps-cdk-align-items-center cmps-cdk-flex-grow-1"
            >
                <div
                    class="cmps-cdk-mr-0dot75 cmps-cdk-font-bold cmps-cdk-font-size-12p"
                >
                    {{ _i18n._822_DRILL_PATH | translate }}
                </div>
                <select
                    cmpsNativeSelect
                    class="cmps-cdk-font-size-14p"
                    (change)="_onDrillPathChange($event)"
                >
                    <ng-container *ngFor="let i of state?.drillPaths">
                        <option
                            [value]="i.identifier"
                            [selected]="
                                i.identifier === state?.selectedDrillPathId
                            "
                        >
                            {{ i.label }}
                        </option>
                    </ng-container>
                </select>
            </div>

            <div
                class="cmps-cdk-d-flex cmps-cdk-mb-1 cmps-cdk-pr-1 cmps-cdk-align-items-center cmps-cdk-flex-grow-1"
            >
                <ng-container *ngIf="state?.hasData === true">
                    <span class="cmps-cdk-font-bold cmps-cdk-mr-0dot5">{{
                        _i18n._7313_LAST_UPDATE | translate
                    }}</span>
                    <span>{{
                        state?.period?.createdOn | cmpsDate: 'MMM d, y, h:mm a'
                    }}</span>
                </ng-container>
            </div>
        </div>
        <div
            class="cmps-cdk-d-flex cmps-cdk-mb-1 cmps-cdk-align-items-flex-end cmps-cdk-flex-column"
        >
            <div
                class="cmps-cdk-d-flex cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4p"
            >
                <button
                    cmpsIconButton
                    class="cmps-icon-button--no-bg"
                    [cmpsTooltipTrigger]="_i18n._9395_RESET_GRID | translate"
                    placement="top-center"
                    (click)="_onResetGridClick()"
                    *ngIf="state?.hasData === true"
                >
                    <cmps-icon svgIcon="reload"></cmps-icon>
                </button>
                <button
                    cmpsIconButton
                    class="cmps-icon-button--no-bg cmps-cdk-border-l-width-1px cmps-cdk-border-l-solid cmps-cdk-border-l-color-grey-300"
                    [cmpsTooltipTrigger]="
                        _i18n._11264_ADDITIONAL_INFORMATION | translate
                    "
                    placement="top-center"
                    (click)="_onInfoClick()"
                    *ngIf="state?.hasData === true"
                >
                    <cmps-icon svgIcon="information"></cmps-icon>
                </button>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="state?.pending?.reload === true">
    <cmps-wait-status></cmps-wait-status>
</ng-container>

<ng-container
    *ngIf="state?.pending?.reload !== true && state?.hasData !== true"
>
    <div class="cmps-cdk-text-center">
        {{ _i18n._10079_NO_WINNING___DATA_IS_AVAILABLE | translate }}
    </div>
</ng-container>

<ng-container
    *ngIf="state?.pending?.reload !== true && state?.hasData === true"
>
    <div>
        <!--ngGrid will measure this div-->
        <div
            ngGrid
            class="cmps-coaching-wp-table"
            [rendererOptions]="_tableData?.rendererOpts"
            [selectTemplate]="_tableData?.selectTpl"
            [rows]="_tableData?.rows"
            [sortDefs]="_tableData?.sortDefs"
        >
            <ng-template
                gridContent
                data-type="grid"
            >
                <div></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="row"
                data-id="header"
            >
                <div
                    class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-font-bold cmps-cdk-font-size-14p cmps-cdk-color-black"
                ></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="cell"
                data-id="header"
                let-c="c"
                let-ctx="ctx"
            >
                <div>
                    <div
                        class="cmps-cdk-bg-color-grey-100"
                        [ngClass]="ctx?.className"
                    >
                        <button
                            class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-w-100pct cmps-cdk-h-100p cmps-cdk-border-width-0p cmps-cdk-cursor-pointer cmps-cdk-font-bold cmps-cdk-font-size-14p cmps-cdk-bg-color-transparent focus:not:focus-visible:cmps-cdk-outline-none cmps-cdk-p-0"
                            (click)="_onColumnSortClick(c)"
                            *ngIf="ctx?.data?.canSort"
                        >
                            <span class="cmps-coaching-wp-table--row--text">
                                {{ ctx?.data?.label | translate }}
                            </span>
                            <!-- cmps-cdk-d-block on cmps-icon, so that the sort chevron icon is part of its width when measured by the grid -->
                            <cmps-icon
                                class="cmps-cdk-d-block"
                                [svgIcon]="
                                    state?.sortOptions?.columnId !== c.id
                                        ? 'unfold-more-horizontal'
                                        : state?.sortOptions?.order ===
                                          _SortOrder.ASC
                                        ? 'chevron-up'
                                        : 'chevron-down'
                                "
                            ></cmps-icon>
                        </button>

                        <div *ngIf="!ctx?.data?.canSort">
                            <span class="cmps-coaching-wp-table--row--text">
                                {{ ctx?.data?.label | translate }}
                            </span>
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-template
                gridContent
                data-type="row"
                data-id="content"
                let-r="r"
            >
                <div
                    class="cmps-coaching-wp-table--row"
                    [class.cmps-coaching-wp-table--row-expand]="
                        r?.context?.ctx?.values?.canExpand
                    "
                    (click)="_onRowClick(r)"
                ></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="cell"
                data-id="content"
                let-c="c"
                let-r="r"
            >
                <div [ngSwitch]="c.id">
                    <div
                        class="cmps-coaching-wp-table--row--left cmps-cdk-border-t-0"
                        [class.cmps-cdk-bg-color-blue-50]="
                            r?.context?.ctx?.values?.isFirstRow === true
                        "
                        [class.cmps-coaching-wp-table--row-grey]="
                            !r?.context?.ctx?.values
                                ?.managerMatchesCurrentManager
                        "
                        *ngSwitchCase="_ColumnId.LEFT"
                    >
                        <div
                            [style.width.px]="r?.context?.ctx?.values?.indentPx"
                            [style.min-width.px]="
                                r?.context?.ctx?.values?.indentPx
                            "
                            [style.max-width.px]="
                                r?.context?.ctx?.values?.indentPx
                            "
                        ></div>
                        <div
                            [cmpsTooltipTrigger]="
                                r?.context?.ctx?.values?.expandIconTooltip
                                    | translate
                            "
                            *ngIf="r?.context?.ctx?.values?.canExpand"
                        >
                            <cmps-icon
                                class="cmps-coaching-wp-table--row-expand--icon"
                                [svgIcon]="r?.context?.ctx?.values?.expandIcon"
                            ></cmps-icon>
                        </div>
                        <div
                            [cmpsTooltipTrigger]="profileTpl"
                            [cmpsTooltipTriggerTemplateContext]="{
                                userId: r?.context?.ctx?.data?.user?.userId
                            }"
                            [cmpsTooltipTriggerCustomTemplate]="true"
                            placement="right-top"
                            *ngIf="r?.context?.ctx?.values?.showUserIcon"
                        >
                            <cmps-icon
                                class="cmps-coaching-wp-table--user-icon cmps-coaching-wp-table--user-icon-blue"
                                *ngIf="
                                    r?.context?.ctx?.values
                                        ?.managerMatchesCurrentManager
                                "
                                svgIcon="account-circle"
                            ></cmps-icon>
                            <cmps-icon
                                class="cmps-coaching-wp-table--user-icon cmps-coaching-wp-table--user-icon-grey"
                                [cmpsTooltipTrigger]="
                                    _i18n._10093_THIS_USER_NO_LONGER_REPORTS_TO_THIS_MANAGER
                                        | translate
                                "
                                *ngIf="
                                    !r?.context?.ctx?.values
                                        ?.managerMatchesCurrentManager
                                "
                                svgIcon="account-circle"
                            ></cmps-icon>
                        </div>
                        <span
                            class="cmps-coaching-wp-table--row--text cmps-cdk-flex-grow-1"
                            *ngIf="!r?.context?.ctx?.values?.showLabelTooltip"
                        >
                            {{ r?.context?.ctx?.values?.label ?? '-' }}
                        </span>
                        <span
                            class="cmps-coaching-wp-table--row--text cmps-cdk-flex-grow-1"
                            [cmpsTooltipTrigger]="
                                r?.context?.ctx?.values?.labelTooltip
                            "
                            *ngIf="r?.context?.ctx?.values?.showLabelTooltip"
                        >
                            {{ r?.context?.ctx?.values?.label ?? '-' }}
                        </span>
                        <button
                            class="cmps-icon-button--no-bg"
                            cmpsIconButton
                            [cmpsTooltipTrigger]="
                                _i18n._11271_LOAD_USER | translate
                            "
                            (click)="
                                $event.stopPropagation();
                                _onLoadUserClick(
                                    r?.context?.ctx?.data?.user?.userId
                                )
                            "
                            *ngIf="r?.context?.ctx?.values?.canLoadNewUser"
                        >
                            <cmps-icon svgIcon="open-in-new"></cmps-icon>
                        </button>
                    </div>
                    <div
                        class="cmps-coaching-wp-table--row--winning-percentage cmps-cdk-border-t-0"
                        [class.cmps-cdk-bg-color-blue-50]="
                            r?.context?.ctx?.values?.isFirstRow === true
                        "
                        [class.cmps-coaching-wp-table--row-grey]="
                            !r?.context?.ctx?.values
                                ?.managerMatchesCurrentManager
                        "
                        *ngSwitchCase="_ColumnId.WINNING_PERCENTAGE"
                    >
                        <cmps-wp-percentage
                            [data]="
                                r?.context?.ctx?.values?.winningPercentageData
                            "
                        ></cmps-wp-percentage>
                    </div>
                    <div
                        class="cmps-coaching-wp-table--row--assessed-commits cmps-cdk-border-t-0"
                        [class.cmps-cdk-bg-color-blue-50]="
                            r?.context?.ctx?.values?.isFirstRow === true
                        "
                        [class.cmps-coaching-wp-table--row-grey]="
                            !r?.context?.ctx?.values
                                ?.managerMatchesCurrentManager
                        "
                        *ngSwitchCase="_ColumnId.ASSESSED_COMMITS"
                    >
                        <button
                            cmpsButton
                            class="cmps-button--no-bg cmps-cdk-w-100pct cmps-cdk-h-100p"
                            [disabled]="
                                !(
                                    r?.context?.ctx?.values
                                        ?.assessedGoalCommitments?.length > 0
                                )
                            "
                            (click)="
                                $event.stopPropagation();
                                _onViewAssessedCommitmentsClick(
                                    r.context?.ctx?.data
                                )
                            "
                        >
                            <span
                                cmpsButtonLabel
                                class="cmps-cdk-font-size-16p cmps-cdk-font-bold cmps-cdk-color-black"
                            >
                                {{
                                    r?.context?.ctx?.values
                                        ?.assessedGoalCommitments?.length ?? 0
                                        | cmpsNumber: '1.0-0'
                                }}
                            </span>
                            <cmps-icon
                                [class.cmps-cdk-fill-blue-100]="
                                    r?.context?.ctx?.values
                                        ?.assessedGoalCommitments?.length > 0
                                "
                                svgIcon="file-search-outline"
                                [cmpsTooltipTrigger]="
                                    _i18n._11206_VIEW_COMMITMENT_DETAILS
                                        | translate
                                "
                            ></cmps-icon>
                        </button>
                    </div>
                    <div
                        class="cmps-coaching-wp-table--row--distribution cmps-cdk-border-t-0"
                        [class.cmps-cdk-bg-color-blue-50]="
                            r?.context?.ctx?.values?.isFirstRow === true
                        "
                        [class.cmps-coaching-wp-table--row-grey]="
                            !r?.context?.ctx?.values
                                ?.managerMatchesCurrentManager
                        "
                        *ngSwitchCase="_ColumnId.DISTRIBUTION"
                    >
                        <div
                            [style.padding-left.px]="
                                r?.context?.ctx?.values?.distributionIndentPx
                            "
                        ></div>
                        <cmps-wp-progress-bar
                            class="cmps-cdk-w-100pct cmps-cdk-pr-1"
                            [distributionData]="
                                r?.context?.ctx?.values?.distributionData
                            "
                            [distributionTooltipData]="
                                r?.context?.ctx?.values?.distributionTooltipData
                            "
                        ></cmps-wp-progress-bar>
                    </div>
                    <div
                        class="cmps-coaching-wp-table--row--excluded-commits cmps-cdk-border-t-0"
                        [class.cmps-cdk-bg-color-blue-50]="
                            r?.context?.ctx?.values?.isFirstRow === true
                        "
                        [class.cmps-coaching-wp-table--row-grey]="
                            !r?.context?.ctx?.values
                                ?.managerMatchesCurrentManager
                        "
                        *ngSwitchCase="_ColumnId.EXCLUDED_COMMITS"
                    >
                        <!-- ToDo: disabled if value is 0 -->
                        <button
                            cmpsButton
                            class="cmps-button--no-bg cmps-cdk-w-100pct cmps-cdk-h-100p"
                            [disabled]="
                                !(
                                    r?.context?.ctx?.values
                                        ?.excludedGoalCommitments?.length > 0
                                )
                            "
                            (click)="
                                $event.stopPropagation();
                                _onViewExcludedCommitmentsClick(
                                    r.context?.ctx?.data
                                )
                            "
                        >
                            <!-- ToDo: add excludedCommits -->
                            <span
                                cmpsButtonLabel
                                class="cmps-cdk-font-size-16p cmps-cdk-font-bold cmps-cdk-color-black"
                            >
                                {{
                                    r?.context?.ctx?.values
                                        ?.excludedGoalCommitments?.length ?? 0
                                        | cmpsNumber: '1.0-0'
                                }}
                            </span>
                            <!-- only Blue if not disabled -->
                            <cmps-icon
                                [class.cmps-cdk-fill-blue-100]="
                                    r?.context?.ctx?.values
                                        ?.excludedGoalCommitments?.length > 0
                                "
                                svgIcon="file-search-outline"
                                [cmpsTooltipTrigger]="
                                    _i18n._11206_VIEW_COMMITMENT_DETAILS
                                        | translate
                                "
                            ></cmps-icon>
                        </button>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</ng-container>

<ng-template
    let-ctx="ctx"
    #profileTpl
>
    <cmps-coaching-user-profile-tooltip
        [userId]="ctx.userId"
    ></cmps-coaching-user-profile-tooltip>
</ng-template>
